var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.988,
    height: 19,
    viewBox: "0 0 18.988 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp-svgrepo-com",
    d: "M20.15,6.755A9.322,9.322,0,0,0,13.5,4,9.429,9.429,0,0,0,5.33,18.119L4,23l4.987-1.306A9.408,9.408,0,0,0,20.15,6.755Zm-6.65,14.5a7.813,7.813,0,0,1-3.99-1.092l-.285-.178-2.957.784.784-2.886-.19-.3A7.869,7.869,0,1,1,13.5,21.254Zm4.287-5.866c-.237-.119-1.389-.689-1.6-.76s-.38-.119-.534.119a10.692,10.692,0,0,1-.748.914c-.131.166-.273.178-.511,0A6.329,6.329,0,0,1,11.2,12.871c-.249-.416.237-.392.689-1.282a.451.451,0,0,0,0-.416c0-.119-.534-1.283-.724-1.746s-.38-.392-.534-.4h-.463a.843.843,0,0,0-.629.3,2.6,2.6,0,0,0-.784,2.007,4.536,4.536,0,0,0,.962,2.434,10.557,10.557,0,0,0,4.026,3.562,4.573,4.573,0,0,0,2.826.594A2.375,2.375,0,0,0,18.143,16.8a1.924,1.924,0,0,0,.142-1.116A1.658,1.658,0,0,0,17.787,15.388Z",
    transform: "translate(-4 -4)",
    fill: "#4e4e4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSvgrepoCom);
export default __webpack_public_path__ + "static/media/whatsapp-svgrepo-com.ad19a6d33f1d483889f86bffde0e295f.svg";
export { ForwardRef as ReactComponent };